import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const ConfirmButton = ({ title, description, confirmLabel = "Delete", onConfirm, children, testId, className }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button type="button" className={className} data-testid={testId}>{children}</button>
    </AlertDialogTrigger>
    <AlertDialogContent className="w-[calc(100vw-2rem)] max-w-md rounded-2xl" data-testid={`${testId}-dialog`}>
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display text-2xl">{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={`${testId}-cancel`}>Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="bg-[#8A2B1E] hover:bg-[#6E2117]" data-testid={`${testId}-confirm`}>{confirmLabel}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
